import { Campaign as CampaignBase, AllowedDeliveryChannel } from "clearline-api";
import { Location, SubscriptionPlan } from ".";

export class LocationCampaignSettings {
  public locationId: number;
  public defaultWidgetSettingsId: number;
  public disabled: boolean;
  public deliveryMethod: AllowedDeliveryChannel;
  public location: Location;
  public defaultWidgetSettings: Campaign;
}

export class SubscriptionWidget {
  public defaultWidgetSettingsId: number;
  public subscriptionPlanId: number;
  public defaultWidgetSettings: Campaign;
  public subscriptionPlan: SubscriptionPlan;
}

/** @deprecated Use import from `clearline-api` */
enum AllowedDeliveryChannelLocal {
  undefined = 0,
  email = 1,
  sms = 2,
  // tslint:disable-next-line:no-bitwise
  emailAndSms = email | sms,
  qr = 64,
  hyperLink = 128,
  all = 16383
}

export { AllowedDeliveryChannelLocal as AllowedDeliveryChannel };

/** @deprecated Use import from `clearline-api` */
export interface Campaign extends CampaignBase {}

export class DefaultWidgetCampaign {
  public defaultWidgetSettingsId: number;
  public textMessage: string;
  public campaignName: string;
  public campaignKeyword: string;
}

export interface WidgetLocationsConfigurationStatusDto {
  widgetSettings: LocationWidgetGetDto;
  configured: boolean;
}

export interface LocationWidgetGetDto {
  id: number;
  locationId: number;
  defaultWidgetSettingsId: number;
  disabled: boolean;
  deliveryMethod: AllowedDeliveryChannel;
  configured: boolean;
  widgetSettingsJson: string;
  location: Location;
  defaultWidgetSettings: Campaign;
}
